import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { HttpClientModule } from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatFormFieldModule} from '@angular/material/form-field';
import { ToastrModule } from 'ngx-toastr';
import { EditorModule } from '@tinymce/tinymce-angular';

import firebase from "firebase/app";
import { environment } from 'src/environments/environment';
firebase.initializeApp(environment);

// import { SharedModule } from './shared/shared.module';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { AppComponent } from './app.component';
import { SignupComponent } from './signup/signup.component';
import { LandingComponent } from './landing/landing.component';
import { ProfileComponent } from './profile/profile.component';
import { HomeComponent } from './home/home.component';

import { LoginComponent } from './login/login.component';
import { AgmCoreModule } from '@agm/core';
import { AboutSycacComponent } from './about-sycac/about-sycac.component';

import { NgCircleProgressModule } from 'ng-circle-progress';
import { ProgramComponent } from './program/program.component';
import { ProjectComponent } from './project/project.component';
import { ContactUsComponent } from './contact-us/contact-us.component';

import { NewsEventsComponent } from './news-events/news-events.component';
import { PhotosLibraryComponent } from './photos-library/photos-library.component';
import { SuccessStoriesComponent } from './success-stories/success-stories.component';
import { SuccessStoryComponent } from './success-story/success-story.component';
import { JoinUsComponent } from './join-us/join-us.component';
import { VolunteeringComponent } from './volunteering/volunteering.component';
import { HomeBlocksComponent } from './home-blocks/home-blocks.component'

import { LatestNewsComponent } from './home-blocks/latest-news/latest-news.component';
import { TestimonialsComponent } from './home-blocks/testimonials/testimonials.component';

import { MapComponent } from './home-blocks/map/map.component';

import { CountersComponent } from './home-blocks/counters/counters.component';
import { AnimatedComponent } from './home-blocks/animated/animated.component';
import { PartnersComponent } from './home-blocks/partners/partners.component';
import { ProgramsHomeComponent } from './home-blocks/programs-home/programs-home.component';
import { MediaComponent } from './home-blocks/media/media.component';

import { SectionsModule } from './sections/sections.module';
///////////// ADMIN 
import { AdminHomeComponent } from './admin/admin-home/admin-home.component';
import { AdminSidebarComponent } from './admin/admin-sidebar/admin-sidebar.component';
import { AdminNavbarComponent } from './admin/admin-navbar/admin-navbar.component';
import { AdminDashboardComponent } from './admin/admin-dashboard/admin-dashboard.component';
import { AdminProjectListComponent } from './admin/admin-projects/admin-project-list/admin-project-list.component';
import { AdminProjectAddComponent } from './admin/admin-projects/admin-project-add/admin-project-add.component';
import { AdminProjectEditComponent } from './admin/admin-projects/admin-project-edit/admin-project-edit.component';
import { AdminProgramEditComponent } from './admin/admin-programs/admin-program-edit/admin-program-edit.component';
import { AdminProgramAddComponent } from './admin/admin-programs/admin-program-add/admin-program-add.component';
import { AdminProgramListComponent } from './admin/admin-programs/admin-program-list/admin-program-list.component';
import { SycacMissionComponent } from './sycac-mission/sycac-mission.component';
import { SycacVisionComponent } from './sycac-vision/sycac-vision.component';
import { SycacValuesComponent } from './sycac-values/sycac-values.component';
import { WhereWeWorkComponent } from './where-we-work/where-we-work.component';
import { AdminVisionComponent } from './admin/about-sycac/admin/admin-vision/admin-vision.component';
import { AdminMissionComponent } from './admin/about-sycac/admin/admin-mission/admin-mission.component';
import { AdminValuesComponent } from './admin/about-sycac/admin/admin-values/admin-values.component';
import { AdminWhereWeWorkComponent } from './admin/about-sycac/admin/admin-where-we-work/admin-where-we-work.component';
import { AdminNewsAddComponent } from './admin/news/admin-news-add/admin-news-add.component';
import { AdminNewsEditComponent } from './admin/news/admin-news-edit/admin-news-edit.component';
import { AdminNewsListComponent } from './admin/news/admin-news-list/admin-news-list.component';
import { AdminSuccessStoriesListComponent } from './admin/success-stories/admin-success-stories-list/admin-success-stories-list.component';
import { AdminSuccessStoriesAddComponent } from './admin/success-stories/admin-success-stories-add/admin-success-stories-add.component';
import { AdminSuccessStoriesEditComponent } from './admin/success-stories/admin-success-stories-edit/admin-success-stories-edit.component';
import { AdminContactUsComponent } from './admin/admin-contact-us/admin-contact-us.component';
import { AdminStaffListComponent } from './admin/join-us/staff/admin-staff-list/admin-staff-list.component';
import { AdminStaffAddComponent } from './admin/join-us/staff/admin-staff-add/admin-staff-add.component';
import { AdminStaffEditComponent } from './admin/join-us/staff/admin-staff-edit/admin-staff-edit.component';
import { AdminVolunteeringComponent } from './admin/join-us/admin-volunteering/admin-volunteering.component';
import { SliderComponent } from './admin/slider/slider.component';
import { AdminSycacComponent } from './admin/admin-sycac/admin-sycac.component';
import { AdminTestimonialListComponent } from './admin/admin-testimonials/admin-testimonial-list/admin-testimonial-list.component';
import { AdminTestimonialAddComponent } from './admin/admin-testimonials/admin-testimonial-add/admin-testimonial-add.component';
import { AdminTestimonialEditComponent } from './admin/admin-testimonials/admin-testimonial-edit/admin-testimonial-edit.component';
import { AdminUsersComponent } from './admin/admin-users/admin-users.component';
import { AdminWorkplaceAddComponent } from './admin/workplaces/admin-workplace-add/admin-workplace-add.component';
import { AdminWorkplaceEditComponent } from './admin/workplaces/admin-workplace-edit/admin-workplace-edit.component';
import { AdminWorkplaceListComponent } from './admin/workplaces/admin-workplace-list/admin-workplace-list.component';
import { HomePageBlocksComponent } from './admin/home-page-blocks/home-page-blocks.component';
import { AdminSycacProfileComponent } from './admin/admin-sycac-profile/admin-sycac-profile.component';
import { AdminPartnerAddComponent } from './admin/partners/admin-partner-add/admin-partner-add.component';
import { AdminPartnerEditComponent } from './admin/partners/admin-partner-edit/admin-partner-edit.component';
import { AdminPartnerListComponent } from './admin/partners/admin-partner-list/admin-partner-list.component';
import { NewsViewComponent } from './news-view/news-view.component';
import { JoinUsViewComponent } from './join-us-view/join-us-view.component';
import { SubscibersListComponent } from './admin/subscibers-list/subscibers-list.component';
import { AdministratorComponent } from './admin/administrator/administrator.component';
import { AdminPhotosLibraryComponent } from './admin/admin-photos-library/admin-photos-library.component';
import { CurrencyExchangeComponent } from './admin/currency-exchange/currency-exchange.component';
import { ProgramsPageComponent } from './programs-page/programs-page.component';

import { DragDropDirective } from './services/drag-drop.directive';
import { SectionAddComponent } from './admin/section/section-add/section-add.component';
import { SectionEditComponent } from './admin/section/section-edit/section-edit.component';
import { SectionListComponent } from './admin/section/section-list/section-list.component';
import { MemberAddComponent } from './admin/members/member-add/member-add.component';
import { MemberEditComponent } from './admin/members/member-edit/member-edit.component';
import { MemberListComponent } from './admin/members/member-list/member-list.component';
import { GalleryListComponent } from './admin/gallery/gallery-list/gallery-list.component';
import { GalleryAddComponent } from './admin/gallery/gallery-add/gallery-add.component';
import { GalleryEditComponent } from './admin/gallery/gallery-edit/gallery-edit.component';
import { SponsorEditComponent } from './admin/sponsor/sponsor-edit/sponsor-edit.component';
import { SponsorAddComponent } from './admin/sponsor/sponsor-add/sponsor-add.component';
import { SponsorListComponent } from './admin/sponsor/sponsor-list/sponsor-list.component';
import { JoinComponent } from './admin/join/join.component';
import { JoinSupportListComponent } from './admin/join-support/join-support-list/join-support-list.component';
import { JoinSupportEditComponent } from './admin/join-support/join-support-edit/join-support-edit.component';
import { JoinSupportAddComponent } from './admin/join-support/join-support-add/join-support-add.component';
import { EventListComponent } from './admin/events/event-list/event-list.component';
import { EventAddComponent } from './admin/events/event-add/event-add.component';
import { EventEditComponent } from './admin/events/event-edit/event-edit.component';
import { VolunteerEditComponent } from './admin/volunteers/volunteer-edit/volunteer-edit.component';
import { VolunteerAddComponent } from './admin/volunteers/volunteer-add/volunteer-add.component';
import { VolunteerListComponent } from './admin/volunteers/volunteer-list/volunteer-list.component';
import { CareerListComponent } from './admin/careers/career-list/career-list.component';
import { CareerEditComponent } from './admin/careers/career-edit/career-edit.component';
import { CareerAddComponent } from './admin/careers/career-add/career-add.component';
import { PressAddComponent } from './admin/press/press-add/press-add.component';
import { PressListComponent } from './admin/press/press-list/press-list.component';
import { PressEditComponent } from './admin/press/press-edit/press-edit.component';
import { HomeEditComponent } from './admin/home/home-edit/home-edit.component';
import { HomeAddComponent } from './admin/home/home-add/home-add.component';
import { HomeListComponent } from './admin/home/home-list/home-list.component';
import { AdminMessagesComponent } from './admin/admin-messages/admin-messages.component';
import { VideosLibraryComponent } from './admin/videos-library/videos-library.component';
import { AboutKhashabehComponent } from './admin/about-khashabeh/about-khashabeh.component';
import { PrivacyKhashabehComponent } from './admin/privacy-khashabeh/privacy-khashabeh.component';
import { PdfLibraryComponent } from './admin/pdf-library/pdf-library.component';
import { ResourcesListComponent } from './admin/resources/resources-list/resources-list.component';
import { ResourcesAddComponent } from './admin/resources/resources-add/resources-add.component';
import { ResourcesEditComponent } from './admin/resources/resources-edit/resources-edit.component';
import { ScriptsListComponent } from './admin/scripts/scripts-list/scripts-list.component';
import { ScriptsAddComponent } from './admin/scripts/scripts-add/scripts-add.component';
import { ScriptsEditComponent } from './admin/scripts/scripts-edit/scripts-edit.component';
import { PerformanceEditComponent } from './admin/performances/performance-edit/performance-edit.component';
import { PerformanceAddComponent } from './admin/performances/performance-add/performance-add.component';
import { PerformanceListComponent } from './admin/performances/performance-list/performance-list.component';
import { ArtistListComponent } from './admin/artists/artist-list/artist-list.component';
import { ArtistEditComponent } from './admin/artists/artist-edit/artist-edit.component';
import { ArtistAddComponent } from './admin/artists/artist-add/artist-add.component';
import { WriterListComponent } from './admin/writer-list/writer-list.component';
import { DirectorListComponent } from './admin/director-list/director-list.component';
import { KindListComponent } from './admin/kind-list/kind-list.component';
import { ResoucesPerListComponent } from './admin/resouces-performances/resouces-per-list/resouces-per-list.component';
import { ResoucesPerNewComponent } from './admin/resouces-performances/resouces-per-new/resouces-per-new.component';
import { ResoucesPerEditComponent } from './admin/resouces-performances/resouces-per-edit/resouces-per-edit.component';
import { WriterListRComponent } from './admin/writer-list-r/writer-list-r.component';
import { ArtistKindListComponent } from './admin/artist-kind-list/artist-kind-list.component';
import { SoundsLibraryComponent } from './admin/sounds-library/sounds-library.component';
import { StreamingComponent } from './admin/streaming/streaming.component';
import { StreamingChatComponent } from './admin/streaming-chat/streaming-chat.component';
import { ResourcesKhashabehComponent } from './admin/resources-khashabeh/resources-khashabeh.component';
import { HomePageBlockComponent } from './admin/home-page-block/home-page-block.component';
import { SeoComponent } from './admin/seo/seo.component';
import { KindsComponent } from './admin/database-blocks/kinds/kinds.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NarratorsComponent } from './admin/database-blocks/narrators/narrators.component';
import { ResearchersComponent } from './admin/database-blocks/researchers/researchers.component';
import { TranslatorsComponent } from './admin/database-blocks/translators/translators.component';
import { EditosComponent } from './admin/database-blocks/editos/editos.component';
import { PlacesComponent } from './admin/database-blocks/places/places.component';
import { ClassificationComponent } from './admin/database-blocks/classification/classification.component';
import { TeamPageComponent } from './admin/team-page/team-page.component';
import { ProjectsList1Component } from './admin/database-blocks/projects-list1/projects-list1.component';
import { AboutProjectComponent } from './admin/about-project/about-project.component';
import { CountriesComponent } from './admin/database-blocks/countries/countries.component';
import { AboutArchiveComponent } from './admin/about-archive/about-archive.component';


///////
@NgModule({
  declarations: [
    AppComponent,
    SignupComponent,
    LandingComponent,
    ProfileComponent,
    HomeComponent,
    LoginComponent,
    AboutSycacComponent,
    ProgramComponent,
    ProjectComponent,
    ContactUsComponent,
    
    NewsEventsComponent,
    PhotosLibraryComponent,
    SuccessStoriesComponent,
    SuccessStoryComponent,
    JoinUsComponent,
    VolunteeringComponent,
    LatestNewsComponent, TestimonialsComponent, MapComponent, CountersComponent, AnimatedComponent, PartnersComponent, ProgramsHomeComponent, MediaComponent, HomeBlocksComponent,
    NavbarComponent,FooterComponent, AdminHomeComponent, AdminSidebarComponent, AdminNavbarComponent, AdminDashboardComponent, AdminProjectListComponent, AdminProjectAddComponent, AdminProjectEditComponent, AdminProgramEditComponent, AdminProgramAddComponent, AdminProgramListComponent, SycacMissionComponent, SycacVisionComponent, SycacValuesComponent, WhereWeWorkComponent, AdminVisionComponent, AdminMissionComponent, AdminValuesComponent, AdminWhereWeWorkComponent, AdminNewsAddComponent, AdminNewsEditComponent, AdminNewsListComponent, AdminSuccessStoriesListComponent, AdminSuccessStoriesAddComponent, AdminSuccessStoriesEditComponent, AdminContactUsComponent,  AdminStaffListComponent, AdminStaffAddComponent, AdminStaffEditComponent, AdminVolunteeringComponent, SliderComponent, AdminSycacComponent, AdminTestimonialListComponent, AdminTestimonialAddComponent, AdminTestimonialEditComponent, AdminUsersComponent, AdminWorkplaceAddComponent, AdminWorkplaceEditComponent, AdminWorkplaceListComponent, HomePageBlocksComponent, AdminSycacProfileComponent, AdminPartnerAddComponent, AdminPartnerEditComponent, AdminPartnerListComponent, NewsViewComponent, JoinUsViewComponent, SubscibersListComponent, AdministratorComponent, AdminPhotosLibraryComponent, CurrencyExchangeComponent, ProgramsPageComponent, DragDropDirective, SectionAddComponent, SectionEditComponent, SectionListComponent, MemberAddComponent, MemberEditComponent, MemberListComponent, GalleryListComponent, GalleryAddComponent, GalleryEditComponent, SponsorEditComponent, SponsorAddComponent, SponsorListComponent, JoinComponent, JoinSupportListComponent, JoinSupportEditComponent, JoinSupportAddComponent, EventListComponent, EventAddComponent, EventEditComponent, VolunteerEditComponent, VolunteerAddComponent, VolunteerListComponent, CareerListComponent, CareerEditComponent, CareerAddComponent, PressAddComponent, PressListComponent, PressEditComponent, HomeEditComponent, HomeAddComponent, HomeListComponent, AdminMessagesComponent, VideosLibraryComponent, AboutKhashabehComponent, PrivacyKhashabehComponent, PdfLibraryComponent, ResourcesListComponent, ResourcesAddComponent, ResourcesEditComponent, ScriptsListComponent, ScriptsAddComponent, ScriptsEditComponent, PerformanceEditComponent, PerformanceAddComponent, PerformanceListComponent, ArtistListComponent, ArtistEditComponent, ArtistAddComponent, WriterListComponent, DirectorListComponent, KindListComponent, ResoucesPerListComponent, ResoucesPerNewComponent, ResoucesPerEditComponent, WriterListRComponent, ArtistKindListComponent, SoundsLibraryComponent, StreamingComponent, StreamingChatComponent, ResourcesKhashabehComponent, HomePageBlockComponent, SeoComponent, KindsComponent, NarratorsComponent, ResearchersComponent, TranslatorsComponent, EditosComponent, PlacesComponent, ClassificationComponent, TeamPageComponent, ProjectsList1Component, AboutProjectComponent, CountriesComponent, AboutArchiveComponent,
    
  ],
  imports: [
    BrowserModule,
    NgbModule,
    FormsModule,
    RouterModule,
    AppRoutingModule,
    SectionsModule,
    AgmCoreModule.forRoot({apiKey:"AIzaSyDhfwqILkC7tgR-Ldrk3jGI0B_C9Yuze6A"}),
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
      
    }),
  
    ToastrModule.forRoot({ timeOut: 8000,positionClass: 'toast-top-right',preventDuplicates:true,resetTimeoutOnDuplicate:true}),
    HttpClientModule,
    // SharedModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    EditorModule,
    NgSelectModule

  ],
  exports: [],
  providers: [HttpClientModule],
  bootstrap: [AppComponent]
})
export class AppModule { }
